import * as React from "react";

const CANVAS_ID = "matrix";

interface IProps {
  animate: boolean;
}

export default class MatrixBackground extends React.Component<IProps> {
  public componentDidUpdate(prevProps: IProps) {
    const { animate } = this.props;
    if (animate && !prevProps.animate) {
      this.animate();
    }
  }

  public render() {
    return (
      <canvas id={CANVAS_ID} style={{ position: "fixed", left: 0, top: 0 }} />
    );
  }

  private animate = () => {
    const c = document.getElementById(CANVAS_ID) as any;
    const ctx = c.getContext("2d");

    c.height = window.innerHeight;
    c.width = window.innerWidth;

    let chinese: any =
      "田由甲申甴电甶男甸甹町画甼甽甾甿畀畁畂畃畄畅畆畇畈畉畊畋界畍畎畏畐畑";
    // converting the string into an array of single characters
    chinese = chinese.split("");

    const font_size = 10;
    const columns = c.width / font_size; // number of columns for the rain
    // an array of drops - one per column
    const drops: any[] = [];
    // x below is the x coordinate
    // 1 = y co-ordinate of the drop(same for every drop initially)
    for (let x = 0; x < columns; x++) {
      drops[x] = 1;
    }

    // drawing the characters
    function draw() {
      // Black BG for the canvas
      // translucent BG to show trail
      ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
      ctx.fillRect(0, 0, c.width, c.height);

      ctx.fillStyle = "rgba(0, 255, 0, 0.25)"; // "#0F0"; // green text
      ctx.font = font_size + "px arial";
      // looping over drops
      for (let i = 0; i < drops.length; i++) {
        // a random chinese character to print
        const text = chinese[Math.floor(Math.random() * chinese.length)];
        // x = i*font_size, y = value of drops[i]*font_size
        ctx.fillText(text, i * font_size, drops[i] * font_size);

        // sending the drop back to the top randomly after it has crossed the screen
        // adding a randomness to the reset to make the drops scattered on the Y axis
        if (drops[i] * font_size > c.height && Math.random() > 0.975) {
          drops[i] = 0;
        }

        // incrementing Y coordinate
        drops[i]++;
      }
    }

    setInterval(draw, 33);
  };
}



// WEBPACK FOOTER //
// ./src/components/MatrixBackground/MatrixBackground.tsx